﻿'use strict'

import * as Backbone from 'backbone';
import * as Entities_Header from '../entities/header';
import config from '../../common/config';

export default (function () {
    var API = {
        notification_init: function () {
            window.app.signalR = {};
            window.app.signalR.badgeCounter = 0;
            window.app.signalR.notification = [];
        },
        getParameterByNameAndUri: function (uri, name) {
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(uri);
            if (results == null)
                return "";
            else
                return decodeURIComponent(results[1].replace(/\+/g, " "));
        },
        GetText: function (color, ActiveTab) {
            var ret = '';

            if (ActiveTab == "Microsoft Teams") {
                if (color == window.app.entities.models.customDepartment.attributes.MSTeams_Color_Online) ret = window.app.entities.models.customDepartment.attributes.MSTeams_Text_Online;
                else if (color == window.app.entities.models.customDepartment.attributes.MSTeams_Color_Busy) ret = window.app.entities.models.customDepartment.attributes.MSTeams_Text_Busy;
                else if (color == window.app.entities.models.customDepartment.attributes.MSTeams_Color_DoNotDisturb) ret = window.app.entities.models.customDepartment.attributes.MSTeams_Text_DoNotDisturb;
                else if (color == window.app.entities.models.customDepartment.attributes.MSTeams_Color_BeRightBack) ret = window.app.entities.models.customDepartment.attributes.MSTeams_Text_BeRightBack;
                else if (color == window.app.entities.models.customDepartment.attributes.MSTeams_Color_ShowAsNotPresent) ret = window.app.entities.models.customDepartment.attributes.MSTeams_Text_ShowAsNotPresent;
                else if (color == window.app.entities.models.customDepartment.attributes.MSTeams_Color_ShowAsOffline) ret = window.app.entities.models.customDepartment.attributes.MSTeams_Text_ShowAsOffline;
            } else if (ActiveTab == "Mutebutton") {
                if (color == window.app.entities.models.customDepartment.attributes.Mutebutton_Color_On) ret = window.app.entities.models.customDepartment.attributes.Mutebutton_Text_On;
                else if (color == window.app.entities.models.customDepartment.attributes.Mutebutton_Color_Off) ret = window.app.entities.models.customDepartment.attributes.Mutebutton_Text_Off;
            } else if (ActiveTab == 'Webhook') {
                if (color == window.app.entities.models.customDepartment.attributes.Pomodoro_Color_Time) ret = window.app.entities.models.customDepartment.attributes.Pomodoro_Text_Time;
                else if (color == window.app.entities.models.customDepartment.attributes.Pomodoro_Color_ShortBreak) ret = window.app.entities.models.customDepartment.attributes.Pomodoro_Text_ShortBreak;
                else if (color == window.app.entities.models.customDepartment.attributes.Pomodoro_Color_LongBreak) ret = window.app.entities.models.customDepartment.attributes.Pomodoro_Text_LongBreak;
            } else {
                if (color == window.app.entities.models.customDepartment.attributes.Custom_Color_Default) ret = window.app.entities.models.customDepartment.attributes.Custom_Text_Default;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Off) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Off;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Busy) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Busy;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Available) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Available;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Blue) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Blue;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Yellow) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Yellow;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Cyan) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Cyan;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Magenta) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Magenta;
                else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_CustomColor) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_CustomColor;
            }

            /*if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Off) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Off;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Busy) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Busy;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Available) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Available;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Blue) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Blue;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Yellow) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Yellow;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Cyan) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Cyan;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_Magenta) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_Magenta;
            else if (color == window.app.entities.models.customDepartment.attributes.SolidColor_Color_CustomColor) ret = window.app.entities.models.customDepartment.attributes.SolidColor_Text_CustomColor;*/

            return ret;
        },
        signalR_init: function () {
            var self = this;

            var url = config.signalRUrl() + '/signalr';

            $.connection.hub.url = url;
            var hub = $.connection.LuxaforboardHub;

            hub.client.hello = function (message) {
            };

            hub.client.addMessage = function (message) {
                var uri = decodeURIComponent(window.location.href + message);
                var SecretKey = self.getParameterByNameAndUri(message, 'SecretKey');
                var SecretCode = self.getParameterByNameAndUri(message, 'SecretCode');
                var Refresh = self.getParameterByNameAndUri(message, 'Refresh');
                //var Department = self.getParameterByNameAndUri(message, 'Department');

                var message_event_str = message.substring(0, message.indexOf("#¤%&/()=?"));
                var message_event = parseInt(message_event_str);
                var correct_message = message.substring(message.indexOf("#¤%&/()=?") + "#¤%&/()=?".length, message.length);

                if (SecretKey == window.infopage.SecretKey && SecretCode == window.infopage.SecretCode) {

                    if (Refresh == 'CallerId') {
                        var CallerId = self.getParameterByNameAndUri(uri, 'CallerId');
                        var Color = '#' + self.getParameterByNameAndUri(uri, 'Color');
                        var ActiveTab = self.getParameterByNameAndUri(uri, 'ActiveTab');
                        var Timestamp = self.getParameterByNameAndUri(uri, 'Timestamp');
                        var Timeleft = self.getParameterByNameAndUri(uri, 'Timeleft');
                        var DepartmentResetText = self.getParameterByNameAndUri(uri, 'DepartmentResetText');

                        var model = window.app.entities.collections.customDepartmentUser.where({ CallerId: CallerId })[0];
                        if (model != undefined) {
                            model.attributes.Color = Color;
                            model.attributes.ActiveTab = ActiveTab;
                            model.attributes.TmpActiveTab = ActiveTab;
                            model.attributes.Text = self.GetText(Color, ActiveTab);
                            model.attributes.Timestamp = Timestamp;
                            model.attributes.Timeleft = parseInt(Timeleft);
                            model.attributes.DepartmentResetText = DepartmentResetText;
                            var userChannel = Backbone.Radio.channel('app');
                            userChannel.trigger('SignalR:ChangeModel', model);
                        }
                    } else if (Refresh == 'Portal') {
                        var Department = self.getParameterByNameAndUri(message, 'Department');
                        if (Department == window.infopage.Department) {
                            window.location.reload();
                        }
                    } else if (Refresh == 'PortalAllDepartment') {
                        window.location.reload();
                    } else if (Refresh == 'ResetTimer') {
                        var Department = self.getParameterByNameAndUri(message, 'Department');
                        if (Department == window.infopage.Department) {
                            window.location.reload();
                        }
                    }
                }
            }

            $.connection.hub.start({ withCredentials: false }).done(function () {
                //hub.server.hello();
                var a = 0;
            });

            $.connection.hub.disconnected(function () {
                setTimeout(function () {
                    $.connection.hub.start();
                }, 5000); // Restart connection after 5 seconds.
            });
        },
    };

    return API;
})();
